import { useEffect, useRef, useState, useCallback } from 'react';

export function useWebSocket() {
  const ws = useRef(null);
  const reconnectTimer = useRef(null);
  const [events, setEvents] = useState([]);
  const [connected, setConnected] = useState(false);

  const connect = useCallback(() => {
    const token = localStorage.getItem('dw_token');
    if (!token) return;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const wsUrl = backendUrl.replace('https://', 'wss://').replace('http://', 'ws://');
    try {
      ws.current = new WebSocket(`${wsUrl}/api/ws?token=${token}`);
      ws.current.onopen = () => {
        setConnected(true);
        if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      };
      ws.current.onclose = () => {
        setConnected(false);
        reconnectTimer.current = setTimeout(connect, 5000);
      };
      ws.current.onerror = () => setConnected(false);
      ws.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          setEvents(prev => [{ ...data, _ts: Date.now() }, ...prev].slice(0, 50));
        } catch {}
      };
    } catch {}
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      if (ws.current) ws.current.close();
    };
  }, [connect]);

  const clearEvents = useCallback(() => setEvents([]), []);

  return { events, connected, clearEvents };
}
